import Vue from 'vue';

export default {
  setLoading (state) {
    state.loading = true;
  },
  resetLoading (state) {
    state.loading = false;
  },
  changeActiveTab (state, index) {
    state.active_tab = state.product_tab.buttons[index].code;
    // ボタンの無効化を解除する
    Vue.set(state.product_tab.buttons, index, {...state.product_tab.buttons[index], 'disabled': false});
    state.product_tab.activeIndex = index + 1;
  },
  setPage (state, page) {
    state.page = page;
  },
  addCart (state, item) {
    state.cart.push(item);
  },
  changeCart (state, payload) {
    state.cart.splice(payload.index, 1, payload.cart);
  },
  removeCart (state, item) {
    state.cart.splice(state.cart.indexOf(item), 1);
  },
  resetCart (state) {
    state.cart = [];
  },
  setOrder(state, order) {
    state.order = order;
  },
  addMessage (state, message) {
    state.messages.push(message);
  },
  setMessages (state, messages) {
    state.messages = messages;
  },
  addFavorites (state, item_id) {
    if (state.favorites.indexOf(item_id) !== -1) return;
    state.favorites.push(item_id);
    window.console.log( state.favorites);
  },
  removeFavorite (state, item_id) {
    state.favorites.splice(state.favorites.indexOf(item_id), 1);
  },
  setItems (state, items) {
    state.items = items;
  },
  resetItems (state) {
    state.items = [];
  },
  setItemNextPageUrl (state, val=null) {
    if (val === null) {
      state.item_next_page_url = 'http://admin.harigu.com/api/items?page=1';
    } else {
      state.item_next_page_url = val;
    }
  },
  setColors (state, colors) {
    state.colors = colors;
  },
  setSelectedColor (state, color) {
    state.selectedColor = color;
  },
  addItems (state, items) {
    state.items = state.items.concat(items);
  },
  setPriceCalculation (state, val) {
    state.price = val;
  },
  setAtLogin (state) {
    state.atLogin = new Date();
  },
};
